

<template>
  <div id="page-home">
    <!-- <div v-if="redirectFrom === 'logout'">Goodbye!</div>
    <div v-else-if="$store.state.justLoggedIn && isAuthenticated">
      Welcome to Pixapup ... Quick how-to: yadda yadda...
    </div>
    <div v-else>You know what to do</div> -->
    <AlertCard
      v-if="showMustBeLoggedOutAlert"
      class="my-4"
      type="error"
      header="Oops: To access that resource..."
      message="...you must log out."
    />

    <!-- <div v-if="authUser">
      <div class="container page-body text-center">
        <button class="btn btn-primary p-3" @click="uploadImage">
          <i class="fas fa-cloud-upload-alt"></i> Upload Your Dog Image!
        </button>
      </div>
    </div> -->

    <div
      v-if="isAuthenticated"
      class="layout-section layout-section--hero layout-section--auth-hero"
    >
      <div class="large-hero large-hero--h180">
        <img
          src="https://pixapup.com/wp-content/uploads/2020/12/app-home-auth-2.jpg"
          alt=""
        />
        <div class="large-hero__content large-hero__content--text-right">
          <h3 class="large-hero__preheadline--text-right">Welcome to</h3>
          <h1 class="large-hero__headline--text-right">Pixapup!</h1>
          <p class="large-hero__text--text-right">
            Keep reading below for a quick how-to overview of the app...
          </p>
        </div>
      </div>
    </div>

    <div v-if="isAuthenticated" class="fw-500 p-3 mx-auto">
      <!-- std double-column  -->
      <div class="info-card">
        <div class="info-card__icon">
          <div class="image-wrapper image-wrapper--width-30m50">
            <img
              src="https://pixapup.com/wp-content/uploads/2020/12/number-1.jpg"
              alt=""
            />
          </div>
        </div>
        <div class="info-card__body">
          <div class="info-card__header">Upload Your Image</div>
          <div class="info-card__text info-card__text--no-link-dec">
            <p>Look above, near the top of the page.</p>
            <p v-if="uploadSlotsAvailable">
              You'll see an "Upload Image" orange button, like this:
              <router-link to="/upload-image"
                ><button
                  class="layout-section__btn layout-section__btn--action-orange layout-section__btn--block-centered"
                >
                  <i class="fas fa-cloud-upload-alt"></i> Upload Image
                </button>
              </router-link>
            </p>
            <div v-else>
              <p>
                You have maxed out your available
                <span class="italic">Upload Slots</span> so you cannot upload a
                new image right now.
              </p>
              <p>
                But when you <span class="italic">can</span> upload again,
                you'll see an "Upload Image" orange button, like this:
                <router-link to="#"
                  ><button
                    class="layout-section__btn layout-section__btn--action-orange layout-section__btn--block-centered"
                  >
                    <i class="fas fa-cloud-upload-alt"></i> Upload Image
                  </button>
                </router-link>
              </p>
            </div>

            <!-- <div v-if="!uploadSlotsAvailable">
              <div class="image-wrapper image-wrapper--width-150">
                <img
                  src="https://pixapup.com/wp-content/uploads/2020/12/upload-button-in-system-bar-193-24.png"
                  alt=""
                />
              </div>
            </div> -->
            <p class="mt-2">
              Click on that to bring up the
              <span class="italic">New Image Upload</span> form. Fill it in and
              submit it. That's it!
            </p>
            <p class="font-weight-bold mt-4">* Time-Saving Tip *</p>
            <p>
              Sure, the upload form is short, but why type the same info over
              and over every time you upload a new image?
            </p>

            <p>
              <strong
                >Go to your
                <router-link to="/profile">Profile/Preferences</router-link>
                page and fill in the
                <span class="italic">One-Click Fill Form Settings</span>
                section.</strong
              >
              Then, with each new upload you do, you simply click the Form-Fill
              button and the text fields will be filled in for you!
            </p>

            <p class="text-center">...</p>
            <p class="text-center">
              <strong
                ><router-link to="/app-overview"
                  >Learn more in App Overview!</router-link
                ></strong
              >
            </p>
          </div>
        </div>
      </div>

      <div class="info-card">
        <div class="info-card__icon">
          <div class="image-wrapper image-wrapper--width-30m50">
            <img
              src="https://pixapup.com/wp-content/uploads/2020/12/number-2.jpg"
              alt=""
            />
          </div>
        </div>
        <div class="info-card__body">
          <div class="info-card__header">You Are Done! But...</div>
          <div class="info-card__text info-card__text--no-link-dec">
            <p>
              <strong>See and track your images</strong> using the multi-colored
              buttons in your Images Summary panel near the top of the page.
              Click a button to view your images in that particular list.
            </p>
            <p class="italic">
              See the Track and Manage Your Images section below for more info
              on your Images Summary panel and each of the four lists.
            </p>
            <p>
              Also, go ahead and
              <strong>upload another image! And another!</strong>
            </p>
            <p>
              You have a set number of
              <span class="italic">Upload Slots</span> you can fill (your
              maximum number is shown in the panel near the top of the page).
              But when slots become available, you can upload more - there's
              <strong>no limit</strong> to the number of images you may upload.
            </p>
            <p class="text-center">...</p>
            <p class="text-center">
              <strong
                ><router-link to="/app-overview"
                  >Learn more in App Overview!</router-link
                ></strong
              >
            </p>
            <p class="font-weight-bold text-center">
              Questions?
              <router-link to="/contact">Contact us!</router-link>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- single-column, text only  -->
    <div v-if="isAuthenticated" class="fw-500 px-3 py-0 mx-auto">
      <div class="info-card info-card--one-col-text-only">
        <div class="info-card__body">
          <div
            class="info-card__header bg-light-gray p-2 info-card__header--one-col"
          >
            Track and Manage Your Images
          </div>
          <div class="info-card__text--one-col">
            <div class="image-wrapper image-wrapper--width-500">
              <img
                src="https://pixapup.com/wp-content/uploads/2020/12/images-summary-panel-labeled.jpg"
                alt=""
              />
            </div>
            <p>
              You'll see this panel near the top of every page. It summarizes
              and gives you access to all your images.
            </p>
            <p class="text-center bg-submit text-white px-3 py-3">
              This allows you to track the status of all your uploaded images at
              <strong>any</strong> time, in <strong>real</strong> time!
            </p>
            <div class="bg-very-light-gray p-2 my-3">
              <p class="font-weight-bold mb-2">
                One Possible Path of Your Uploaded Image:
              </p>
              <p>
                <strong>Uploads -> Selected -> Published</strong>
              </p>
            </div>

            <p>
              When you <strong>upload</strong> a new image, it appears in your
              <strong>Uploads</strong> list (orange button).
            </p>
            <p>
              When we select your image for a book or calendar, the image moves
              from your Uploads list and appears in your
              <strong>Selected</strong> list (blue button).
            </p>
            <p>
              When the project is completed and published, your image moves from
              the Selected list and appears in your
              <strong>Published</strong> list (green button).
            </p>
            <p class="text-center">...</p>
            <p class="text-center">
              <strong
                ><router-link to="/app-overview"
                  >Learn more in App Overview!</router-link
                ></strong
              >
            </p>
            <p class="font-weight-bold text-center">
              Questions?
              <router-link to="/contact">Contact us!</router-link>
            </p>
          </div>

          <div class="image-wrapper image-wrapper--width-500">
            <img
              src="https://pixapup.com/wp-content/uploads/2020/12/taking-pic-cspaniel-mobile-phone-600w.jpg"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="redirectFrom === 'logout'" class="container">
      <div
        class="layout-section layout-section__image-wrap layout-section__image-wrap--w600"
      >
        <h2>You have logged out - bye for now!</h2>
        <img
          src="https://pixapup.com/wp-content/uploads/2020/12/jack-wave-bye-600-512.jpg"
          alt=""
        />
        <div class="layout-section--bg-light-gray">
          <div class="fw-400 p-3 layout-section--centered">
            <p class="font-weight-bold">Be sure to come back soon!</p>
            <p>
              You can check if your uploads have been selected or published and
              see where to get the calendars and books featuring YOUR dog(s)!
            </p>
            <p>
              And, we hope you consider uploading more images of your dog(s).
              The more you upload, the more likely they will be published, and
              that means we can donate to more rescue groups to help them do
              what they do: Find loving homes for as many of their dogs as
              possible.
            </p>
            <p class="font-weight-bold">
              Thank you from all of us here at Pixapup!
            </p>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!isAuthenticated"
      class="layout-section layout-section--hero layout-section--noauth-hero"
    >
      <div class="large-hero large-hero--h300">
        <img
          src="https://pixapup.com/wp-content/uploads/2020/11/app-home-noauth.jpg"
          alt=""
        />
        <div class="large-hero__content large-hero__content--text-left">
          <h1 class="large-hero__headline--text-left">
            <span class="text-larger-1-2em font-weight-bold">Your dog</span>
            in our next book or calendar
          </h1>

          <h2 class="large-hero__subheadline--text-left">
            helps
            <span class="text-larger-1-2em font-weight-bold">dogs in need</span>
            find their forever home!
          </h2>
          <h3
            class="large-hero__headlinetag--text-left large-hero__headlinetag--limit-width"
          >
            Upload your photos now...
          </h3>
          <h3 class="large-hero__headlinetag--text-left">
            It's fast, secure, and free!
          </h3>

          <router-link
            to="/login"
            class="large-hero__btn-left btn btn-outline-accent-green"
          >
            Login
          </router-link>
          <router-link
            to="/signup"
            class="large-hero__btn-right btn btn-outline-accent-green"
          >
            Signup
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertCard from '@/components/notifications/AlertCard';

import { mapGetters } from 'vuex';
export default {
  name: 'HomePage',
  components: {
    AlertCard,
  },
  data() {
    return {
      pageAccess: '',
      redirectFrom: '',
    };
  },

  computed: {
    ...mapGetters('auth', ['authUser', 'isAuthenticated']),
    ...mapGetters('uploadTracker', ['imageCounts']),

    maxNumUploads: function () {
      return this.imageCounts.maxNumPending || 0;
    },

    numPending: function () {
      return this.imageCounts.numSubmitted + this.imageCounts.numPending || 0;
    },

    showMustBeLoggedOutAlert: function () {
      return this.pageAccess === 'onlyLoggedOut' ? true : false;
    },

    uploadSlotsAvailable: function () {
      if (this.numPending < this.maxNumUploads) {
        return true;
      }
      return false;
    },
  },

  methods: {
    uploadImage: function () {
      console.log(this.$route);
      this.$router.push('/upload-image');
    },
    runCode: function () {
      console.log(this);
      // setTimeout(() => {
      //   this.$parent.rerenderStatsBar();
      //   console.log(this.$parent);
      // }, 2000);
    },

    runCodeXX: function () {
      var docListeners = this.$store.getters.docListeners;
      Object.values(docListeners).forEach((f) => f());

      // var f = function() {
      //   return function() {
      //     console.log("Hello from a nameless function!");
      //   };
      // };
      // var newFunc = f();
      // var storeIt = {};
      // storeIt["sayHello"] = newFunc;
      // // storeIt.sayHello();
      // var serFunc = newFunc.toString();
      // console.log(serFunc);
      // var restoredFunc = new Function("return " + serFunc)();
      // console.log("about to call deserialized function...");
      // restoredFunc();
    },
  },
  created() {
    // Check if this visitor was sent as a referral: Query param 'r' will be defined:
    var refByCode = this.$route.query.r;
    if (refByCode) {
      // Check local storage for an existing referral code; if so, do nothing since the rule is 'first person to refer new user sticks'.
      // If not, check if the detected referral code (in the query string) *could* be an actual referral code, i.e. it fits the pattern.
      // If it passes the pattern text, we'll store it; if not, do nothing.
      if (!localStorage.getItem('refByCode')) {
        if (/^par[2-9]-[a-z2-9]{5}$/i.test(refByCode)) {
          localStorage.setItem('refByCode', refByCode);
          // With refByCode stored, when user hits the signup page, THAT component will check local storage for it and use it
          // during signup.
        }
      }
    }

    this.redirectFrom = this.$store.state.loginRdq;
    this.$store.dispatch('setLoginRdq', '');

    // console.log('Home Page Reporting: CAME FROM:', document.referrer);
    // test - test
    // this.$store.state.appIsReady = 'no!';
    // console.log('state: appIsReady:', this.$store.getters.appReady);

    this.pageAccess = this.$store.state.pageAccess;
    this.$store.dispatch('setPageAccess', '');

    // console.log(this.$route);
    //this.authUser = this.$store.getters['auth/authUser'];
    // console.log('authUser', this.authUser);

    // console.log(this.$store.getters["auth/authUser"]);
  },
};
</script>

<style>
/* .my-image {
  margin: 2rem auto;
  width: 70%;
  max-width: 500px;
}
.my-image img {
  width: 100%;
} */
</style>